export default {
  id: "rendering-basics-assignment",
  pride: 11264,
  slug: "rendering-basics-assignment",
  portfolioKind: "study",
  category: "game",
  status: "released",
  titleKey: {
    zh: "纯C++《渲染基础》游戏作业",
    en: "Pure C++ Rendering Basics — Game Assignment"
  },
  bilibiliVideoId: "BV1CP411V7J4",
  date: { year: 2022, month: 9, day: 3 },
  descriptionKey: {
    zh: "课程作业小解谜游戏。地形手刻，植被手刷，模型手放，交互逻辑自己写。",
    en: "Course assignment puzzle game. Terrain sculpted by hand, foliage painted by hand, models placed by hand, interaction logic self-written."
  },
  genres: ["解谜", "课程作业"],
  themes: ["渲染", "C++"],
  engine: "虚幻引擎",
  platform: ["PC"],
  developerNotesKey: {
    zh: "《渲染基础》课程游戏制作作业。地形手刻，植被手刷，模型手放，交互自己写。纯C++。",
    en: "Game assignment for the Rendering Basics course. Terrain, foliage, and model placement all done manually. Interactions self-coded in pure C++."
  },
  tags: ["C++", "课程作业"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1CP411V7J4/", textKey: { zh: "B站视频", en: "Bilibili Video" } }
  ]
};
